import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<path d=\"M13 19V13H19V11H13V5H11V11H5V13H11V19H13Z\" fill={{this.pathColor}}></path>", {
  moduleName: "@dashboard/shared-ui/components/svgs/market/action-plus.hbs"
});